










































import Vue from 'vue';
import ZenMultiselect from '@reciprocity/multiselect';
import { cloneDeep, isArray } from 'lodash';
import PrintableMultiselect from './PrintableMultiselect.vue';

export interface HeatmapFilterEntry {
  label: string;
  value: string;
}

export default Vue.extend({
  name: 'HeatmapFilter',
  components: {
    ZenMultiselect,
    PrintableMultiselect,
  },
  props: {
    options: {
      type: Array as () => HeatmapFilterEntry[],
      default: () => [],
    },
    value: {
      // Can be array (multi-select) or single id (single-select):
      type: [Array, String, Object], // object can be only null
      default: () => [],
    },
    // Vue-multiselect exposed props:
    placeholder: {
      type: String,
      default: 'Select option',
    },
    name: {
      type: String,
      default: 'heatmap-filter',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      selectedOptions: '',
    };
  },
  computed: {
    isMultiselect() {
      return isArray(this.value);
    },
    myOptions() {
      return cloneDeep(this.options);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (this.loading) return;
        this.selectedOptions = this.idsToOptions(value);
      },
      deep: true,
    },
    myOptions: {
      handler(options) {
        if (this.loading) return;
        this.selectedOptions = this.idsToOptions(this.value, options);
      },
      deep: true,
    },
  },
  methods: {
    optionsToIds(options): object | string | null {
      return this.isMultiselect ? options.map(o => o.value) : options.value;
    },
    idsToOptions(ids: string[] | string, options: object): any {
      options = options || this.myOptions;
      const findOption = (value: any) =>
        options.find(o => {
          return o.value === value;
        });

      return this.isMultiselect ? (ids || []).map(findOption).filter(o => o !== undefined) : findOption(ids);
    },
    onChange(value: any) {
      this.$emit('input', this.optionsToIds(value));
    },
  },
});
